/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import dynamic from 'next/dynamic';

import React, { Fragment, useEffect, useState } from "react";
import { SwiperSlide } from "swiper/react";
import Web3 from "web3";
import { fetchVideoBanner } from '@/utils/helpers/helperFunctions';

const VideoBanner = dynamic(() => import('@/components/new/general/VideoBanner'), { ssr: false });
const Button = dynamic(() => import('@/components/ui/Button'));

const ChainPage = () => {
  const [items, setItems] = useState([
    {
      title: "Secure",
      description: "Industry leading security model created by Avalanche.",
      iconImg:
        "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Ficon_secure.png?alt=media&token=122a04d3-d520-422a-ae37-18d0f5330c31",
    },
    {
      title: "Scalable",
      description: "Lower latency, higher throughput, and reduced costs.",
      iconImg:
        "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Ficon_scalable.png?alt=media&token=c5002c3e-0e37-41c0-a252-de5dd3fde402",
    },
    {
      title: "Decentralised",
      description:
        "Gaming spesific rules & consensus mechanisms, reducing the risk of failure.",
      iconImg:
        "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Ficon_decentralised.png?alt=media&token=6ab3a2d5-8c14-4032-8dcb-b7c2882e784e",
    },
    {
      title: "Managed",
      description:
        "Blockchain infrastructure maintained by the world class team at Ava Labs.",
      iconImg:
        "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Ficon_managed.png?alt=media&token=b2113f71-3f0c-4dca-a6de-0bf6e384ec0b",
    },
  ]);

  const [videoBannerURL, setVideoBannerURL] = useState(null);
  const [videoBannerMobileURL, setVideoBannerMobileURL] = useState(null);

  useEffect(() => {
    // Fetch the video banner for the chain page
    fetchVideoBanner("chain", setVideoBannerURL, setVideoBannerMobileURL);
  }, []);

  // Read latest block and total transaction
  const [latestBlock, setLatestBlock] = useState(null);
  const [totalTransactions, setTotalTransactions] = useState(null);

  useEffect(() => {
    const fetchBlockchainData = async () => {
      try {
        console.log("Fetching blockchain data...");

        const web3 = new Web3(
          "https://subnets.avax.network/mxsgameste/testnet/rpc"
        );

        // Fetch the latest block number
        console.log("Fetching latest block number...");
        const latestBlockNumber = await web3.eth.getBlockNumber();
        console.log("Latest block number:", latestBlockNumber);
        setLatestBlock(latestBlockNumber.toLocaleString());

        // Fetch the total number of transactions
        console.log("Fetching total number of transactions...");
        const block = await web3.eth.getBlock(latestBlockNumber);
        const txCount = block.transactions.length;
        console.log("Total transactions:", txCount);
        setTotalTransactions(txCount.toLocaleString());
      } catch (error) {
        console.error("Error fetching blockchain data:", error);
      }
    };

    fetchBlockchainData();
  }, []);

  return (
    <Fragment>
      <VideoBanner>
        <SwiperSlide>
          <div
            className={`swiperSlideDiv relative w-full transition-transform duration-[600ms] ease-in-out`}
          >
            <video
              preload="auto"
              src={
                videoBannerURL ||
                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Fxseed_chain.mp4?alt=media&token=0f06769f-bdc6-436d-8cfc-d6005e79c432"
              }
              autoPlay
              loop
              muted
              playsInline
              className="object-cover w-full h-full hidden md:block"
            />

            <video
              preload="auto"
              src={
                videoBannerMobileURL ||
                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_chain%2Fxseed_chain.mp4?alt=media&token=0f06769f-bdc6-436d-8cfc-d6005e79c432"
              }
              autoPlay
              loop
              muted
              playsInline
              className="object-cover w-full h-full md:hidden"
            />
          </div>
        </SwiperSlide>
      </VideoBanner>

      <div className="!pr-8 !pl-8 py-8 xl:container mt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex relative flex-col items-stretch bg-metaxseed-blue rounded-xl p-4 shadow-lg"
            >
              <div className="dotted-bg-pattern"></div>
              <div className="py-4 mb-4 text-center gothamBlack text-xl text-white ">
                {item.title.toUpperCase()}
              </div>
              <div className="p-4 flex-1 flex-col flex items-center justify-between bg-metaxseed-dark-gray rounded-xl text-metaxseed-text-gray gothamBook 2xl:min-h-[200px]">
                <div className="md:max-w-[50%] 2xl:max-w-[70%] mt-4 mb-4 flex text-center justify-center text-xs items-center">
                  {item.description}
                </div>
                <div className="flex justify-center items-center mt-8 2xl:mt-0">
                  <img alt="" src={item.iconImg} className="h-16" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-8 my-16">
          <div>
            <div className="bg-metaxseed-dark-gray text-white w-full px-4 py-2 rounded-xl gothamMedium font-normal text-base border-2 border-[#3a3a3c] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none gothamMedium !shadow-none">
              Latest Block: {latestBlock}
            </div>
          </div>
          <div>
            <div className="bg-metaxseed-dark-gray text-white w-full px-4 py-2 rounded-xl gothamMedium font-normal text-base border-2 border-[#3a3a3c] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none gothamMedium !shadow-none">
              {/* Total Transactions: {totalTransactions} */}
              Active Wallets: 1500+
            </div>
          </div>

          <div className="w-full">
            <Button
              text="Visit Testnet"
              onClick={() => {
                window.open(
                  "https://subnets-test.avax.network/mxsgameste/",
                  "_blank"
                );
              }}
              className="bg-metaxseed-blue text-white w-full px-10 py-2 rounded-xl gothamMedium font-normal text-base border-2 border-[#3a3a3c] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:jello-horizontal gothamMedium !shadow-none"  
            />
          </div>
          <div className="w-full">
            <Button
              text="Visit Faucet"
              onClick={() => {
                window.open(
                  "https://core.app/tools/testnet-faucet?subnet=mxsgames&token=mxsgames",
                  "_blank"
                );
              }}
              className="bg-metaxseed-blue text-white w-full px-10 py-2 rounded-xl gothamMedium font-normal text-base border-2 border-[#3a3a3c] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:jello-horizontal gothamMedium !shadow-none"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChainPage;
